import React, { useState, useRef } from 'react';
import { api } from '../../api';
import { Alert } from '../../components/UI';

export default function ImportExport() {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [details, setDetails] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  async function handleUpload(e) {
    e.preventDefault();
    const file = fileRef.current.files[0];
    if (!file) return;
    setUploading(true);
    setError(''); setSuccess(''); setDetails([]);
    try {
      const form = new FormData();
      form.append('file', file);
      const res = await api.post('/import-export/questions', form);
      setSuccess(`Imported ${res.inserted} question(s).`);
      fileRef.current.value = '';
    } catch (err) {
      setError(err.message);
      if (err.details) setDetails(err.details);
    }
    setUploading(false);
  }

  return (
    <div className="content-narrow">
      <div className="page-header">
        <div>
          <div className="eyebrow">Exam setup</div>
          <h1>Import / export</h1>
        </div>
      </div>

      <div className="card">
        <h3>Download template</h3>
        <p>Use this spreadsheet format to prepare questions in bulk, then upload it below.</p>
        <button
          className="btn btn-outline"
          onClick={() => api.download('/import-export/template.xlsx', 'question-upload-template.xlsx').catch(e => setError(e.message))}
        >
          Download template.xlsx
        </button>
      </div>

      <div className="card mt-4">
        <h3>Upload questions</h3>
        <p>All rows are validated before anything is saved &mdash; if any row fails, nothing is imported.</p>
        <Alert type="danger">{error}</Alert>
        <Alert type="success">{success}</Alert>
        {details.length > 0 && (
          <ul className="text-sm" style={{ color: 'var(--danger)' }}>
            {details.map((d, i) => <li key={i}>{d}</li>)}
          </ul>
        )}
        <form onSubmit={handleUpload}>
          <div className="form-group">
            <input type="file" accept=".xlsx" ref={fileRef} required />
          </div>
          <button className="btn btn-primary" type="submit" disabled={uploading}>{uploading ? 'Uploading…' : 'Upload'}</button>
        </form>
      </div>

      <div className="card mt-4">
        <h3>Export question bank</h3>
        <p>Download every active question in the same spreadsheet format.</p>
        <button
          className="btn btn-outline"
          onClick={() => api.download('/import-export/questions.xlsx', 'question-bank.xlsx').catch(e => setError(e.message))}
        >
          Download question-bank.xlsx
        </button>
      </div>
    </div>
  );
}
